import isEqual from 'react-fast-compare';
import pxtTheme from '..';
export const isLegacyCustomizedTheme = theme => {
  if (theme === undefined) {
    return false;
  } else {
    if (theme.color !== undefined) {
      console.warn("The legacy stencil theme value passed using <StencilProvider theme={theme}/> is deprecated and will be removed in Stencil 5.x release.\n        Please check https://stencil.a2z.com/develop/theming for more details on using new theming system.");
      return true;
    }
    return false;
  }
};
export const isLegacyDefaultTheme = theme => {
  return isEqual(theme, pxtTheme);
};